export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        link: "/",
        icon: "bx-home-circle",
    },

    {
        id: 3,
        label: "menuitems.bookings.text",
        link: "/bookings",
        icon: "bxs-calendar-check",
    },


    {
        id: 4,
        label: "menuitems.counters.text",
        link: "/counters",
        icon: "bxs-store",
    },

    {
        id: 8,
        label: "menuitems.outsourceTokenCalls.text",
        link: "/outsource-token-calls",
        icon: "bx-list-ul",
    },

    {
        id: 5,
        label: "menuitems.tvs.text",
        link: "/tvs",
        icon: "bx-desktop",
    },

    {
        id: 7,
        label: "menuitems.tvshows.text",
        link: "/tvshows",
        icon: "bx-tv",
    },

    {
        id: 6,
        label: "menuitems.profile.text",
        link: "/profile",
        icon: "bxs-user-circle",
    },
];

